export const KeyboardCodeEnum = {
  KEY_LEFT_ARROW: 37,
  KEY_UP_ARROW: 38,
  KEY_RIGHT_ARROW: 39,
  KEY_DOWN_ARROW: 40,
  KEY_ESCAPE: 27,
  KEY_ENTER: 13,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/KeyboardCodeEnum.js